import { omit } from "lodash";
import { ROW_NUMBER_COLUMN } from "../elements/table/TableElement/constants";
import { TableRow } from "../types";

export const omitTableRowIndex = (row: TableRow): TableRow =>
  omit(row, ROW_NUMBER_COLUMN.key);
